import { render, staticRenderFns } from "./ControlClient.vue?vue&type=template&id=5aa94649&scoped=true&"
import script from "./ControlClient.vue?vue&type=script&lang=js&"
export * from "./ControlClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa94649",
  null
  
)

export default component.exports